import { Modal } from "@ucchub/ui";
import { ReactNode } from "react";
import { Stack, Warning } from "@ucchub/ui";
import Heading from "@vfuk/core-heading";
import Button from "@vfuk/core-button/";
import Spacing from "@vfuk/core-spacing";

type Props = {
  isOpen: boolean;
  heading: string;
  body: ReactNode;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
  srName: string;
};

const WarningModal = ({
  isOpen,
  heading,
  body,
  confirmText,
  onConfirm,
  onCancel,
  cancelText,
  srName,
}: Props) => {
  const handleOnClose = () => {
    onCancel?.();
  };

  return (
    <Modal
      srName={srName}
      isOpen={isOpen}
      size={2}
      animate
      isClosable
      onClose={handleOnClose}
    >
      <Stack justifyContent="center" direction="column" align="center">
        <Warning />
        <Spacing spacingLevel={{ top: 6, bottom: 3 }}>
          <Heading level={4} weight={3} justify="center">
            {heading}
          </Heading>
        </Spacing>
        {body}
        <Spacing spacingLevel={{ top: 3 }}>
          <Stack columnGap="10px">
            <Button
              width="auto"
              appearance="alt1"
              text={cancelText}
              onClick={onCancel}
            />
            <Button
              width="auto"
              appearance="primary"
              text={confirmText}
              onClick={onConfirm}
            />
          </Stack>
        </Spacing>
      </Stack>
    </Modal>
  );
};

export default WarningModal;
